import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from './AuthContext';
import styled from 'styled-components';
import { UserPlus } from 'lucide-react';
import AuthLayout from './AuthLayout';
import { StyledButton as CommonStyledButton, AlertBox } from '../main/CommonStyles';

const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.md};
    width: 100%;
`;

const StyledInput = styled.input`
    padding: ${({ theme }) => theme.spacing.md};
    border: 1px solid ${({ theme }) => theme.colors.borderColor};
    border-radius: ${({ theme }) => theme.borderRadius};
    font-size: 1rem;
    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primary};
        box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primaryLightest};
    }
`;

const FooterLinkText = styled.p`
    text-align: center;
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.textMedium};
    margin-top: ${({ theme }) => theme.spacing.lg};
    a {
        color: ${({ theme }) => theme.colors.primary};
        font-weight: 600;
        text-decoration: none;
        &:hover { text-decoration: underline; }
    }
`;

const RegisterPage = () => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { register } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('Hasła nie są zgodne.');
            return;
        }
        setError('');
        setLoading(true);
        try {
            // Przekazujemy puste imię i nazwisko, bo to standardowa rejestracja
            await register(username, email, password, "", "");
            navigate('/login', { state: { message: 'Rejestracja pomyślna! Możesz się teraz zalogować.' } });
        } catch (err) {
            setError(err.response?.data?.message || 'Rejestracja nie powiodła się.');
        }
        setLoading(false);
    };

    return (
        <AuthLayout title="Utwórz konto" subtitle="Dołącz do nas i zadbaj o swój dobrostan.">
            {error && <AlertBox style={{ marginBottom: '1rem' }}>{error}</AlertBox>}
            <StyledForm onSubmit={handleSubmit}>
                <StyledInput type="text" placeholder="Nazwa użytkownika" value={username} onChange={(e) => setUsername(e.target.value)} required disabled={loading} />
                <StyledInput type="email" placeholder="Adres e-mail" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={loading} />
                <StyledInput type="password" placeholder="Hasło (min. 6 znaków)" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} disabled={loading} />
                <StyledInput type="password" placeholder="Potwierdź hasło" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required disabled={loading} />
                <CommonStyledButton type="submit" disabled={loading} style={{width: '100%'}}>
                    <UserPlus size={18} style={{ marginRight: '8px' }} />
                    {loading ? 'Rejestrowanie...' : 'Zarejestruj się'}
                </CommonStyledButton>
            </StyledForm>
            <FooterLinkText>
                Masz już konto? <Link to="/login">Zaloguj się</Link>
            </FooterLinkText>
        </AuthLayout>
    );
};

export default RegisterPage;